//送信エリア
import React, { useState, useEffect }  from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import { TextField, Typography, FormGroup, FormControl, Select, MenuItem, Tooltip } from '@material-ui/core';
import DeliveryButton from './DeliveryButton';
import RequestCheckBox from './RequestCheckBox';
import axios from 'axios';
import Common from '../../Common';
import HelpToolTip from '../HelpToolTip';

const styles = () => ({
    paper: {
        // margin: '5px 5px 5px 50px',
        margin: '0 auto',
        width: 1150
    },
    textField: {
        display: 'flex',
        boxShadow: '0px 2.5px 1px -1px rgba(0,0,0,0.2)',
        fontSize: '18px',
    },
    lengthTypography: {
        fontSize: '22px',
        display: 'flex',
        textAlign: 'right',
        justifyContent:'right',
    },
    errString:{
        color: '#ff0000',
        fontSize: '20px'
    },
    titleLabel:{
        ontSize: '20px',
        marginTop: '30px'
    },
    titleField: {
        display: 'flex',
        boxShadow: '0px 2.5px 1px -1px rgba(0,0,0,0.2)',
        fontSize: '18px',
        marginTop: '10px',
        width: 750
    },
    title:{
        fontSize: '25px',
        marginTop: '30px',
    },
    selectKubunArea: {
        marginTop:'20px',
    },
    deletionFlgList:{
        borderBottom: 'solid 2px #FFF',
        height:'40px',
    },
    keyword:{
        left: '30px',
        //marginLeft: '1px',
        width: 400
    },
    categoryChatList: {
        width: '300px',
        marginBottom: '20px'
    },
    inputKeyword:{
        justifyContent:'center',
        alignItems: 'center',
        margin: '13px 0px 10px 0px',
    },
    selectedKubun:{
        justifyContent:'center',
        alignItems: 'center',
        margin: '0px 0px 10px 10px',
        fontSize: '19px',
    }
});

//メッセージ送信の最大文字数
const maxString = 5000;

const MsgArea = withCookies((props) => {
    const { classes, userData, cookies, nickName, selectedKubunName, selectedKubunId, setSelectedKubunId} = props;
    const [categoryChatList, setCategoryChatList] = React.useState([]);
    const [displayChatName, setDisplayChatName] = React.useState('---選択してください---');
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [errFlg, setErrFlg] = useState(false);
    //宛名連携機能を利用する場合
    const availableAddress = cookies.get('AVAILABLE_ADDRESS') === 'TRUE' ? true : false;
    const [chatRequestFlg, setChatRequestFlg] = useState(availableAddress);
    const chatNameObj = cookies.get('COMMON_NAME_OBJ');
    const kubunName = chatNameObj !== undefined ? chatNameObj.KUBUN_NAME : 'チャットカテゴリ';
    const talkName = chatNameObj !== undefined ? chatNameObj.TALK_NAME : 'チャット';
    const supportedPersonId = cookies.get('supportedPersonId');
    //配信タイトルのヘルプ文言
    const infoText = `LINEトーク画面には表示されない職員管理用のタイトルです。\n${talkName}履歴、メッセージ送信履歴で確認できます。`;

    //-----------------------------------------------------------------
    //              ページに格納するデータの取得
    //-----------------------------------------------------------------
    function getChatData() {
        if(categoryChatList.length === 0){
            //TOKEN取得
            axios.post(
                `${Common.apiServerUrl()}/api/auth/token`,
                    {},
                    {
                        headers: {
                            'Authorization': 'Bearer ' + cookies.get('id_token')
                        },
                    }
                )
                .then(Common.handleErrors)
                .then((Response) => {
                    if (Response.success) {
                        cookies.set('token', Response.token, {
                            maxAge: 60 * 60 * 24 * 30, //30日間
                            httpOnly: false,
                            path: '/',
                            secure: true,
                        });

                        const jichitaiToken = cookies.get('x-jichitai-token');
                        const jichitaiId = cookies.get('x-jichitai-jichitaiid');

                        //-------------------------------------------
                        //プルダウンに表示する情報区分の取得 APIアクセス先(johoKubun.js)
                        //cookieに保存している職員番号でGetアクセスを行う
                        //-------------------------------------------
                        // -------------------------axios------------------------------
                        axios.get(
                            `${Common.apiServerUrl()}/api/counseling/getResponsibleKubun`,
                            {
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                    'x-suppportcenter-token': Response.token,
                                    'x-jichitai-jichitaiid': jichitaiId,
                                    'x-jichitai-token': jichitaiToken,
                                },
                                params: {
                                    supportedPersonId
                                }
                            })
                            .then(Common.handleErrors)
                            .then((response) => {
                                const res = response.getResponsibleKubunArray;
                                if (response.success) {
                                    if (res.length === 0) {
                                        return;
                                    } else {
                                        const categoryList = [];
                                        res.map((d) => {
                                            if(d.counselingKubunId !== '00' && d.counselingKubunId !== 'all'){
                                                const resObj = {
                                                    categoryName: d.counselingKubunName,
                                                    categoryId: d.counselingKubunId
                                                };
                                                categoryList.push(resObj);
                                            }
                                        });
                                        setCategoryChatList(categoryList);
                                    }
                                } else {
                                    window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                                }
                            })
                            .catch((err) => {
                                console.error('ChatUserSearch.js :get err:' + err.message);
                            });
                    }
                })
                .catch((err) => {
                    console.error('ChatUserSearch.js :get err:' + err.message);
                });
        }
    }

    function handleChatChange(categoryId){
        if(categoryId !== '' ){
            setSelectedKubunId(categoryId);
            const selectChat = categoryChatList.filter((d) => d.categoryId === categoryId);
            setDisplayChatName(selectChat[0].categoryName);
        }
        else{
            setSelectedKubunId('');
            setDisplayChatName('---選択してください---');
        }
    }

    useEffect(() => {
        if(categoryChatList.length === 0) getChatData();
    },[]);

    const handleChange = (event) => {
        const msg = event.target.value;
        setMessage(msg);
        if (maxString < msg.length) {
            setErrFlg(true);
        }else{
            setErrFlg(false);
        }
    }

    return (
        <React.Fragment>
            <div elevation={3} className={classes.paper} >
                { nickName !== '' && (
                    <Typography className={classes.title}>
                        {`送信者名：${nickName} `}
                    </Typography>
                )}
                <RequestCheckBox
                    chatRequestFlg={chatRequestFlg}
                    setChatRequestFlg={setChatRequestFlg}
                    setDisplayChatName={setDisplayChatName}
                    setSelectedKubunId={setSelectedKubunId}
                />
                { chatRequestFlg && !availableAddress && (
                    <FormGroup className={classes.selectKubunArea} row>
                        <Typography variant="body1" className={classes.inputKeyword}>
                                {`${kubunName}：`}
                        </Typography>
                        <FormControl className={classes.keyword}>
                            {/* */}
                            <Select
                                id="multiple-checkbox-johoKubun"
                                value={displayChatName}
                                className={classes.categoryChatList}
                                variant="outlined"
                            >
                                <MenuItem key={0} value={'---選択してください---'} className={classes.deletionFlgList} onClick={() => handleChatChange('')}>{'---選択してください---'}</MenuItem>
                                {categoryChatList.map((rec, i) => (
                                    <MenuItem key={i+1} value={rec.categoryName} onClick={() => handleChatChange(rec.categoryId)} className={classes.deletionFlgList}>
                                        {`${rec.categoryName}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </FormGroup>
                )}
                { chatRequestFlg && availableAddress && (
                    <FormGroup className={classes.selectKubunArea} row>
                        <Typography variant="body1" className={classes.selectedKubun}>
                                {`${kubunName}： ${selectedKubunName}`}
                        </Typography>
                    </FormGroup>
                )}
                <Typography className={classes.titleLabel}>
                    {'配信タイトル：'}
                    <HelpToolTip infoText={infoText}/>
                </Typography>
                <TextField
                    placeholder={'メッセージ送信履歴を見たときにわかりやすいタイトルを入力してください。'}
                    className={classes.titleField}
                    onChange={(event) => setTitle(event.target.value)}
                    name="Text"
                    margin="normal"
                    variant="outlined"
                    value={title}
                />
                <TextField
                    label={'メッセージ入力欄'}
                    className={classes.textField}
                    multiline
                    error={errFlg}
                    maxRows={13}
                    minRows={13}
                    onChange={(event) => handleChange(event)}
                    name="Text"
                    margin="normal"
                    variant="outlined"
                    value={message}
                />
                {errFlg && (
                    <Typography className={classes.errString}>{'最大文字数を超えています'}</Typography>
                )}
                <Typography className={classes.lengthTypography}>{message.length + '/' + maxString}</Typography>
            </div>
            <DeliveryButton
                userData={userData}
                message={message}
                kubunId={selectedKubunId}
                title={title}
                chatRequestFlg={chatRequestFlg}
                msgMaxString={maxString} />
        </React.Fragment>
    );
});

export default withStyles(styles)(MsgArea);